import { SSO_CALLBACK_BROADCAST_CHANNEL } from "core/constants"

export function detectSSOTokensForBrodcast(): boolean {
  const urlParams = new URLSearchParams(window.location.href.split("?")[1])
  const accessToken = urlParams.get("accessToken")
  const refreshToken = urlParams.get("refreshToken")

  if (accessToken && refreshToken) {
    const url = new URL(window.location.href)
    url.searchParams.delete("accessToken")
    url.searchParams.delete("refreshToken")
    window.history.replaceState({}, document.title, url.toString())

    const bc = new BroadcastChannel(SSO_CALLBACK_BROADCAST_CHANNEL)
    bc.postMessage(`${window.location.origin}/?refreshToken=${refreshToken}`)
    bc.close()

    return true
  }

  return false
}
